export default {
  path: '/2019GoAheadChina',
  name: '2019GoAheadChina',
  component: () => import('./Home.vue'),
  redirect: '/2019GoAheadChina/ListPage',
  meta: {
    title: '前进，中国！',
  },
  children: [
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: 'ListPAge',
      meta: {
        title: '前进，中国！',
      },
    },
  ],
};
